import { createReducer, on } from '@ngrx/store';
import * as pageActions from '../actions/collections.action';
import * as utility from '../../../utility';
import { Collection } from '../../models';

export interface CollectionsState {
  entities: { [id: number]: Collection };
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: CollectionsState = {
  entities: {},
  loaded: false,
  loading: false,
};

export const CollectionReducer = createReducer(
  initialState,
  on(pageActions.LoadCollections, (state: CollectionsState) => {
    return {
      ...state,
      loaded: false,
      loading: true,
      error: null,
    };
  }),
  on(pageActions.LoadCollectionsSuccess, (state: CollectionsState, { collections }) => {
    const entities = utility.ToEntities(collections, 'id', state.entities);
    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
      error: null,
    };
  }),
  on(pageActions.LoadCollectionsFail, (state: CollectionsState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  }),
  on(pageActions.LoadCollectionByHandle, (state: CollectionsState) => {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }),
  on(pageActions.LoadCollectionByHandleSuccess, (state: CollectionsState, { collection, handle }) => {
    const entities = { ...state.entities, [collection.id]: { ...collection, originalHandle: handle } };
    return {
      ...state,
      entities,
      loading: false,
      error: null,
    };
  }),
  on(pageActions.LoadCollectionByHandleFail, (state: CollectionsState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getCollectionsEntities = (state: CollectionsState) => state.entities;
export const getCollectionsLoading = (state: CollectionsState) => state.loading;
export const getCollectionsLoaded = (state: CollectionsState) => state.loaded;
export const getCollectionsError = (state: CollectionsState) => state.error;
